import { render } from "./OrdersHome.vue?vue&type=template&id=68a2d4d7&ts=true"
import script from "./OrdersHome.vue?vue&type=script&lang=ts"
export * from "./OrdersHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__